import React, {useContext, useEffect, useRef, useState} from 'react';
import Icon from '../Icon/Icon';
import Product from '../Product/Product';
import Lang from '../Lang/Lang';
import {
  ClientWidthContext,
  ModalContext, ModalDispatchContext, SearchContext, SearchDispatchContext,
} from '../Context/ApplicationContextProvider';
import ProductInSearch from '../Product/ProductInSearch';
import {
  apiBaseUrl,
  axiosInstance, esputnikTracker,
  hoverUnderlineClass,
  lang, sessid,
  underlineClass,
} from '../../common/baseData';
import Cookies from 'js-cookie';

function SearchResult(props) {
  const {
    additionalClass,
    topPosition,
    inPageMobile,
  } = {...props};

  const {
    query,
    start,
    direct,
    productList,
    categoryList,
    historyList,
    promotedProducts,
    potentialQueryList,
    total,
    totalLink,
  } = useContext(SearchContext);
  const dispatchSearch = useContext(SearchDispatchContext);

  const clientWidth = useContext(ClientWidthContext);

  const isMobile = clientWidth < 1024;

  const mobileClassName = `flex flex-col ${inPageMobile ? '' : 'fixed left-0 right-0'} z-30 min-h-96 w-full bg-white gap-5 overflow-y-scroll`;
  const desktopClassName = `flex absolute top-0 z-30 left-0 min-h-96 h-auto right-0 w-[calc(100%+20px)] bg-white pt-3 pb-8 px-5`;

  const promotedTitleMobileClassName = `text-[16px] leading-[24px] text-grey-90 font-medium`;
  const promotedTitleDesktopClassName = `text-[16px] leading-[21px] text-grey-90 font-medium`;

  const promotedProductMobileClassName = `min-w-[171px] w-[171px] p-4`;
  const promotedProductDesktopClassName = `min-w-[240px] w-[240px] px-10 py-6`;

  const mobileTop = `${topPosition}px`;

  const searchPage = `${lang === 'ru' ? '/' : `/${lang}/`}search/`;

  // признак показа продвигаемых товаров
  const showPromotedProducts = promotedProducts &&
    Array.isArray(promotedProducts.items) &&
    promotedProducts.items.length > 0;

  /**
   * событие смены прискового запроса
   */
  useEffect(() => {
    if (query.length <= 1) return;
    search(query);
  }, [query]);

  /**
   * Executes a search query and updates the state with the search results.
   *
   * @param {string} query - The search query to be executed.
   * @return {void}
   */
  function search(query) {
    axiosInstance.post(`${apiBaseUrl}search/query`, {
      'query': query,
    }).then(response => response.data).then(data => {
      // direct logic
      let total_link = '';
      let products = [];
      let catogories = [];
      let potential_query_List = [];
      let count = 0;
      let direct = null;

      if (data.hasOwnProperty('ITEMS')) {
        total_link = searchPage + '?q=' + query;
        products = data['ITEMS'];
        // esputnik search event
        esputnikTracker.SearchRequest(query,
          Array.isArray(data.ITEMS) && data.ITEMS.length ? 1 : 0);
      }
      if (data.hasOwnProperty('SECTIONS')) catogories = data['SECTIONS'];
      if (data.hasOwnProperty(
        'POTENTIAL_QUERY_LIST')) potential_query_List = data['POTENTIAL_QUERY_LIST'];
      if (data.hasOwnProperty('TOTAL')) count = data['TOTAL'];

      direct = data.hasOwnProperty('DIRECT') && data.DIRECT !== null &&
      data.DIRECT.length ?
        data.DIRECT :
        null;

      // обрезаем кол-во до 5 на mobile
      if (isMobile && Array.isArray(products) && products.length > 5) {
        products = products.slice(0, 5);
      }

      let payload = {
        'totalLink': total_link,
        'productList': products,
        'categoryList': catogories,
        'potentialQueryList': potential_query_List,
        'total': count,
        'direct': direct,
      };

      dispatchSearch({type: 'update', payload: payload});
    }).catch(reason => console.log(reason));
  }

  /**
   * удаление элемента истории поиска
   * @param query
   */
  function onRemoveHistoryItem(query) {
    axiosInstance.post(`${apiBaseUrl}search/removeHistoryEntry`,
      {'query': query}).
      then(response => response.data).
      then(response => {
        if (response.hasOwnProperty('HISTORY') &&
          Array.isArray(response.HISTORY))
          dispatchSearch(
            {type: 'update', payload: {'historyList': response.HISTORY}});
      }).
      catch(reason => console.log(reason));
  }

  /**
   * очистка всей истории поиска
   */
  function onClearHistory() {
    axiosInstance.post(`${apiBaseUrl}search/clearHistory`, {}).
      then(response => response.data).
      then(response => {
        if (response.hasOwnProperty('HISTORY') &&
          Array.isArray(response.HISTORY))
          dispatchSearch(
            {type: 'update', payload: {'historyList': response.HISTORY}});
      }).
      catch(reason => console.log(reason));
  }

  function onSubmitQuery(searchQueryOverride = null) {
    if (searchQueryOverride === null && !!direct && direct.length) {
      // TEH-1606 (F36): direct из внешнего API — абсолютный переход только на свой домен
      if (direct.startsWith('https://')) {
        if (direct.startsWith(window.location.origin + '/')) {
          window.location.href = direct;
        }
      } else if (!direct.startsWith('//')) {
        window.location.href = lang === 'ua' ?
            `/${lang}${direct}` :
            direct;
      }
    } else {
      // Определяем URL для поиска
      const targetUrl = searchQueryOverride !== null
        ? searchPage
        : total ? totalLink.split('?')[0] : searchPage;
      const searchQuery = searchQueryOverride !== null
        ? searchQueryOverride
        : total ? totalLink.split('q=')[1] : inputValue;

      // Создаем временную форму для POST запроса
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = targetUrl + '?q=' + encodeURIComponent(searchQuery);
      form.style.display = 'none';

      // Добавляем параметр поиска
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'q';
      input.value = searchQuery;

      // Добавляем параметр сессии
      const inputSessid = document.createElement('input');
      inputSessid.type = 'hidden';
      inputSessid.name = 'sessid';
      inputSessid.value = sessid;

      form.appendChild(input);
      form.appendChild(inputSessid);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  }

  // признак показа левой части
  const showLeftSide = (Array.isArray(historyList) && historyList.length > 0) ||
    (Array.isArray(categoryList) && categoryList.length > 0) ||
    (Array.isArray(potentialQueryList) && potentialQueryList.length > 0);

  const rightSideWidth = showLeftSide && !isMobile
    ? 'w-[calc(100%-315px)]'
    : 'w-full';

  useEffect(() => {
    let calculated = clientWidth < 1024;
    if (isMobile !== calculated) setIsMobile(calculated);
  }, [clientWidth]);

  /**
   * Обработчик перехода на страницу категории с POST-параметром поиска
   * @param {Event} event - Событие клика
   * @param {string} filterPageUrl - URL с параметрами GET (старый формат)
   */
  function handleCategoryFilter(event, filterPageUrl) {
    event.preventDefault(); // Предотвращаем стандартный переход по ссылке

    // Разделяем URL на базовый путь и параметры
    const [basePath, queryString] = filterPageUrl.split('?');
    const queryParams = new URLSearchParams(queryString);
    const searchQuery = queryParams.get('q');

    // Создаем форму для POST-запроса
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = basePath; // Базовый путь без GET-параметров
    form.style.display = 'none';

    // Добавляем параметр q как поле формы
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'q';
    input.value = searchQuery;
    form.appendChild(input);

    // Если нужен CSRF-токен (для защиты от CSRF-атак)
    if (typeof sessid !== 'undefined') {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'sessid';
      csrfInput.value = sessid;
      form.appendChild(csrfInput);
    }

    // Добавляем форму на страницу, отправляем и удаляем
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  return (
    <div id="search-result"
         className={`${inPageMobile ? 'fixed top-0 bottom-0 left-0 right-0' : ''} relative`}>
      <div className={`${isMobile
        ? `${additionalClass} ${mobileClassName}`
        : desktopClassName} overscroll-y-none`}
           style={{
             height: isMobile ? `calc(100dvh - ${mobileTop})` : '',
             top: isMobile ? mobileTop : '',
           }}>

        {
          showLeftSide && (
            <div className={`${!isMobile
              ? 'w-[290px] mr-5'
              : ''} flex flex-col shrink-0 relative px-5`}>
              {/** потенциальные запросы **/
                Array.isArray(potentialQueryList) &&
                potentialQueryList.length > 0 && (
                  <div className={`flex flex-col gap-3 mt-1 desktop:mt-0 mb-5 `}>
                    <span className={'text-[16px] leading-[21px] text-grey-90 font-medium'}>
                      {Lang.getMessage('maybeYouSearched')}
                    </span>
                    <ul className={`flex ${isMobile
                      ? 'w-full flex-wrap'
                      : 'flex-col'} gap-2.5`}>
                      {/** история поисковых запросов **/
                        potentialQueryList.map((suggestion, key) => {
                          return (
                            <li
                              className="flex justify-between items-center bg-grey-15 w-max py-1 px-2 rounded-[14px]"
                              key={`suggestion-${key}`}>
                            <span
                              className="text-[13px] leading-[20px] text-black cursor-pointer search-suggestion"
                              dangerouslySetInnerHTML={{__html: suggestion}}
                              onClick={event => {
                                let clearedSuggestion = suggestion.replace(
                                  /<\/?[^>]+(>|$)/ig, '');
                                console.info('click on suggestion: ',
                                  suggestion, clearedSuggestion);
                                dispatchSearch({
                                  type: 'setQuery',
                                  payload: clearedSuggestion,
                                });
                                onSubmitQuery(clearedSuggestion);
                              }}/>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                )
              }
              {/** история поисковых запросов **/
                Array.isArray(historyList) &&
                historyList.length > 0 && (
                  <div className={'flex flex-col gap-3'}>
                    <div className={`flex justify-between items-center`}>
                  <span className={'text-[16px] leading-[21px] text-grey-90 font-medium'}>
                    {Lang.getMessage('searchHistory')}
                  </span>
                      <button
                        className={'text-[14px] leading-[21px] font-medium text-blue-primary bg-transparent underline border-0 p-0'}
                        onClick={
                          () => onClearHistory()
                        }>{Lang.getMessage('clear')}
                      </button>
                    </div>
                    <ul className={`flex flex-col gap-2.5`}>
                      {/** история поисковых запросов **/
                        historyList.map((query, key) => {
                          return (
                            <li className="flex justify-between items-center"
                                key={`history-item-${key}`}>
                              <span className={'flex gap-2.5 items-center'}>
                                <Icon name={'history-icon'}
                                      className="h-6 w-6 min-w-6"/>
                                <span
                                  className="text-[14px] leading-[21px] text-grey-90 cursor-pointer"
                                  onClick={event => {
                                    dispatchSearch({
                                      type: 'setQuery',
                                      payload: query,
                                    });
                                  }}>
                                  {query}
                                </span>
                              </span>
                              <Icon name={'close-icon'}
                                    className="h-4 w-4 min-w-4 cursor-pointer"
                                    onClick={() => onRemoveHistoryItem(query)}/>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                )
              }
              {/** найденные категории **/
                Array.isArray(categoryList) &&
                categoryList.length > 0 && (
                  <div className={'flex flex-col gap-3 mt-4.5'}>
                <span className={'text-[16px] leading-[21px] text-grey-90 font-medium'}>
                  {Lang.getMessage('popularCategories')}
                </span>
                    <ul className={`flex flex-col gap-2.5`}>
                      {
                        categoryList.map((category, key) => {
                          return (
                            <li key={`founded-category-${key}`}
                                className="flex justify-between items-center">
                              <span
                                  onClick={(e) => handleCategoryFilter(e, category.FILTER_PAGE_URL)}
                                  className={`text-[14px] leading-[21px] cursor-pointer dsa text-grey-90 ${hoverUnderlineClass}`}>
                                {category.NAME}
                              </span>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                )
              }
            </div>
          )
        }

        <div
          className={`${rightSideWidth} flex ${showPromotedProducts && !isMobile
            ? ''
            : 'flex-col'}`}>

          {/** список продвигаемых товаров **/
            query.length <= 0 && showPromotedProducts && (
              <div className={'flex flex-col gap-3 w-full'}>
                <span className={`${isMobile
                  ? promotedTitleMobileClassName
                  : promotedTitleDesktopClassName} ${isMobile ? 'pl-5' : ''}`}>
                  {Lang.getMessage('You might like it')}
                </span>
                <ul className={`w-full ${isMobile
                  ? 'px-5'
                  : 'px-4'} desktop:px-0 flex overflow-x-scroll scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar`}>
                  {
                    promotedProducts.items.map((item, index) => (
                      <Product {...item}
                               hideActions
                               rootClassName={`flex flex-col relative shrink-0 ${isMobile
                                 ? promotedProductMobileClassName
                                 : promotedProductDesktopClassName} ${index ===
                               promotedProducts.items.length - 1 ? '' : 'border-r-0'}`}
                               gaParams={promotedProducts.gaParams}
                               key={`promoted-${item.ID}`}
                               itemKey={`promoted-${item.ID}`}/>
                    ))
                  }
                </ul>
              </div>
            )
          }

          {/** список найденных товаров **/
            Array.isArray(productList) && productList.length > 0 && query.length > 1 && (
              <div className={`flex flex-col ${isMobile ? 'px-5' : ''} w-full`}>
                <span className={'text-[16px] leading-[21px] text-grey-90 font-medium'}>
                  {Lang.getMessage('Popular products')}
                </span>
                <ul
                  className={`desktop:h-[490px] w-full flex flex-col gap-1 overflow-y-scroll scroll-smooth snap-y snap-mandatory visible-scrollbar-y mt-3`}>
                  {
                    productList.map((item, index) => (
                      <ProductInSearch {...item}
                                       key={`founded-product-${item.ID}`}
                                       itemKey={`founded-product-${item.ID}`}/>
                    ))
                  }
                </ul>
                <div className={`${isMobile
                  ? 'pt-5 pb-10 border-0 border-solid border-t border-grey-30'
                  : 'mt-auto'} flex items-center justify-center`}>
                  <span
                     onClick={(e) => {
                       e.preventDefault();
                       onSubmitQuery();
                     }}
                     className={`text-[15px] leading-[20px] text-[#6364ff] cursor-pointer hover:underline hover:underline-offset-2`}>
                    {Lang.getMessage('Show all products')} ({total})
                  </span>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

export default SearchResult;